import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { CustomResponse } from '@ascschool/model/custom-response.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LevelOfDevelopmentService } from '@ascschool/services/school/level-of-development.service';
import { LevelOfDevelopmentTypesService } from '@ascschool/services/school/level-of-development-types.service';
import { DisStudentLevelOfDevelopment } from '@ascschool/model/school/student-level-of-development';

@Component({
  selector: 'app-popup-level-of-dev',
  templateUrl: './popup-level-of-dev.component.html',
  styleUrls: ['./popup-level-of-dev.component.scss']
})
export class PopupLevelOfDevComponent implements OnInit {
  validateForm =  new FormGroup({
    levelOfDevelopment: new FormControl(''),
    levelOfDevelopmentTypes: new FormControl(''),
  });
  @Input() schoolId: any;
  @Input() value: any;
  item: DisStudentLevelOfDevelopment = new DisStudentLevelOfDevelopment();
  response: CustomResponse = new CustomResponse();
  getLevelOfDevelopmentACFn: (value: any) => Observable<any>;
  LevelOfDevelopmentSubscription: any;
  LevelOfDevelopmentControl = this.validateForm.controls.levelOfDevelopment;
  getLevelOfDevelopmentTypesACFn: (value: any) => Observable<any>;
  LevelOfDevelopmentTypesSubscription: any;
  LevelOfDevelopmentTypesControl = this.validateForm.controls.levelOfDevelopmentTypes;
  isEditMode = false;
  errorMsg: string;
  isDisabled = false;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private levelOfDevelopmentService: LevelOfDevelopmentService,
    private levelOfDevelopmentTypesService: LevelOfDevelopmentTypesService
  ) {
  }

  ngOnInit() {
    if(this.value){
      this.GetById(this.value);
    }
    this.loadLevelOfDevelopment();
    this.loadLevelOfDevelopmentTypes();
  }
  GetById(value){
    this.levelOfDevelopmentService.getById(value.levelOfDevelopment.id).subscribe(res =>{
      this.LevelOfDevelopmentControl.setValue({id: res.id , text: res.name});
    });
    this.levelOfDevelopmentTypesService.getById(value.levelOfDevelopmentTypes.id).subscribe(res =>{
      this.LevelOfDevelopmentTypesControl.setValue({id: res.id , text: res.name});
    });
  }
  UpdateClose() {
    if (this.item.levelOfDevelopmentId && this.item.levelOfDevelopmentTypeId) {
      this.item.levelOfDevelopmentName = this.LevelOfDevelopmentControl.value.text;
      this.item.levelOfDevelopmentTypeName = this.LevelOfDevelopmentTypesControl.value.text;
      this.response.data = this.item;
      this.response.status = true;
      this.modal.close(this.response);

    } else {
      this.msg.warning('Vui lòng nhập trường bắt buộc');
    }
    // if (this.validateForm.valid) {
    //   this.response.data = this.validateForm.value;
    //   this.response.status = true;
    //   this.modal.close(this.response);
    //   this.msg.success('Thành công');
    // } else {
    //   this.msg.warning('Vui lòng nhập trường bắt buộc');
    // }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(this.response);
  }

  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  loadLevelOfDevelopment() {
    this.getLevelOfDevelopmentACFn = (value: any) => this.levelOfDevelopmentService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LevelOfDevelopmentSubscription) this.LevelOfDevelopmentSubscription = this.LevelOfDevelopmentControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.item, 'levelOfDevelopmentId', this.LevelOfDevelopmentControl.value);
    });
  }
  changeLevelOfDevelopment(control: FormControl) {
    this.LevelOfDevelopmentControl = control;
  }
  loadLevelOfDevelopmentTypes() {
    this.getLevelOfDevelopmentTypesACFn = (value: any) => this.levelOfDevelopmentTypesService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LevelOfDevelopmentTypesSubscription) this.LevelOfDevelopmentTypesSubscription = this.LevelOfDevelopmentTypesControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.item, 'levelOfDevelopmentTypeId', this.LevelOfDevelopmentTypesControl.value);
    });
  }
  changeLevelOfDevelopmentTypes(control: FormControl) {
    this.LevelOfDevelopmentTypesControl = control;
  }
}
